package cz.lhoracek.mapl.ui

import androidx.compose.ui.graphics.Color

fun getInitials(name: String): String {
    val words = name.trim().split(Regex("\\s+")).filter { it.isNotBlank() }
    return if (words.isEmpty()) {
        ""
    } else if (words.size == 1) {
        words[0].take(1).uppercase()
    } else {
        words.take(4).joinToString("") { it.take(1).uppercase() }
    }
}

fun hexToColor(hex: String): Color {
    val h = hex.trimStart('#')
    return try {
        val r = h.substring(0, 2).toInt(16)
        val g = h.substring(2, 4).toInt(16)
        val b = h.substring(4, 6).toInt(16)
        Color(r, g, b)
    } catch (e: Exception) {
        Color.Gray
    }
}
